var _module = require('../components/module.js');

/*
convertToSqft
Converts a number less then 100 to sqft
*/
_module.filter('convertToSqft', function () {
    return function addCommas(str) {
        var value = parseFloat(str);

        if(!value) return str;

        if(value < 100) {
            value = value * 43560;
        }

        return value;
    };
});
